/**
 * ページタイトルを設定するフック
 * @param title - ページタイトル
 */
function usePageTitle(title: string) {
  document.title = title;
}

export default usePageTitle;
